<div class="parties formfields-padding">
  <div class="formfields" fxLayout="row wrap">
    <div class="formfields__container" fxFlex="50">
      <h3 *ngIf="transaction.rep_role === 'client'" i18n>Client Details</h3>
      <h3 *ngIf="transaction.rep_role === 'buyer'" i18n>Buyer</h3>
      <h3 *ngIf="transaction.rep_role === 'seller'" i18n>Seller</h3>
      <h3 *ngIf="transaction.rep_role === 'borrower'" i18n>Borrower</h3>
      <h3 *ngIf="transaction.rep_role === 'lender'" i18n>Lender</h3>
      <h3 *ngIf="transaction.deal_type_agile_space === 'fill'; else tenantLandlordTemplate" i18n>Operator</h3>
      <ng-template #tenantLandlordTemplate>
        <h3 *ngIf="transaction.rep_role === 'landlord'" i18n>Landlord</h3>
        <h3 *ngIf="transaction.rep_role === 'tenant'" i18n>Tenant</h3>
      </ng-template>

      <ng-container *ngIf="!isPacificIsolationEnable() || transaction.rep_role !== 'client'">
        <mat-form-field *ngIf="!transaction.bill_to_third_party_customer" class="parties__name">
          <label for="represented_name" i18n>Name</label>
          <input id="represented_name" matInput  [value]="transaction.represented_contact_name" disabled />
        </mat-form-field>
        <mat-form-field class="parties__company">
          <label for="represented_company-parties" i18n>Company</label>
          <input id="represented_company-parties" matInput  [value]="companyFullName" disabled />
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="transaction.is_ip_metro_business_line">
        <mat-form-field class="parties__ip_metro_represented_name">
          <label for="ip_metro_represented_name" i18n>
            <span *ngIf="transaction.rep_role === 'buyer'">Buyer Name</span>
            <span *ngIf="transaction.rep_role === 'seller'">Seller Name</span>
            <span class="required">*</span>
          </label>
          <input id="ip_metro_represented_name" matInput [value]="transaction.ip_metro_represented_name" disabled />
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="isPacificIsolationEnable()">
        <mat-form-field class="parties__name">
          <label for="represented_account" i18n>Account</label>
          <input id="represented_name" matInput  [value]="edpAccountContactInfo?.represented_party_account || ''" disabled />
        </mat-form-field>
        <mat-form-field class="parties__company">
          <label for="represented_contact" i18n>Contact</label>
          <input id="represented_contact" matInput  [value]="edpAccountContactInfo?.represented_party_contact || ''" disabled />
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="enableInCapacityAndCareOfNotes">
        <form [formGroup]="notesForm" novalidate>
          <iv-notes-field 
            class="note-field"
            headerNote="In Capacity Notes" i18n-headerNote 
            subheaderNote="(Appears in Invoice)" i18n-subheaderNote 
            placeHolder="Add Note Here" i18n-placeHolder
            controlName="in_capacity_notes"
            formControlName="in_capacity_notes">
          </iv-notes-field>
        </form>
      </ng-container>

      <div *ngIf="transaction.transaction_type === 'sale'">
        <mat-form-field class="parties__vehiclename">
          <label for="represented_vehicle_name" i18n>Fund Name</label>
          <input id="represented_vehicle_name" maxLength="256" matInput [value]="transaction.represented_funding_vehicle" disabled />
        </mat-form-field>
        <mat-form-field class="parties__sourceequity">
          <label *ngIf="transaction.rep_role === 'buyer'" for="represented_equity_source" i18n>Origin of Buyer</label>
          <label *ngIf="transaction.rep_role === 'seller'" for="represented_equity_source" i18n>Origin of Seller</label>
          <input id="represented_equity_source" maxLength="256" matInput [value]="transaction.represented_equity_source" disabled />
        </mat-form-field>
      </div>

      <div *ngIf="!transaction.bill_to_third_party_customer && !isPacificIsolationEnable()" class="parties__address selected-value">
        <label for="address1" class="selected-value__label" i18n>Address</label>
        <div id="address1" class="selected-value__details address">
          <button mat-button matInput disabled>
            <div *ngIf="transaction.represented_party">
              <div class="address__name">{{represented_party[0]?.name1}}</div>
              <div class="address__line">{{ represented_party[0]?.addresses?.addresses[0]?.address_seq_num ? represented_party[0]?.addresses?.addresses[0]?.address_seq_num + '. ' : '' }} {{represented_party[0]?.addresses?.addresses[0]?.address1}}</div>
              <div class="address__line">{{represented_party[0]?.addresses?.addresses[0]?.address2}}</div>
              <div class="address__line">{{represented_party[0]?.addresses?.addresses[0]?.address3}}</div>
              <div class="address__line">{{represented_party[0]?.addresses?.addresses[0]?.address4}}</div>
              <div class="address__line">
                <span>{{represented_party[0]?.addresses?.addresses[0]?.city}}, </span>
                <span *ngIf="represented_party[0]?.addresses?.addresses[0]?.state">
                  {{represented_party[0]?.addresses?.addresses[0]?.state}},
                </span>
                <span>{{represented_party[0]?.addresses?.addresses[0]?.postal}}, </span>
                <span>{{represented_party[0]?.addresses?.addresses[0]?.country}}</span>
              </div>
              <div class="address__line"
                *ngIf="represented_party[0]?.addresses?.addresses[0]?.stx_cst_rgstn && represented_party[0]?.addresses?.addresses[0]?.stx_cst_rgstn !== ''">
                GSTIN: {{ represented_party[0]?.addresses?.addresses[0]?.stx_cst_rgstn }}
              </div>
            </div>
          </button>
        </div>

        <ng-container *ngIf="enableInCapacityAndCareOfNotes">
          <form [formGroup]="notesForm" novalidate>
            <iv-notes-field
              class="note-field" 
              headerNote="Care of Notes" i18n-headerNote 
              subheaderNote="(Appears in Invoice)" i18n-subheaderNote 
              placeHolder="Add Note Here" i18n-placeHolder
              controlName="care_of_notes"
              formControlName="care_of_notes">
            </iv-notes-field>
          </form>
        </ng-container>
      </div>
    
    </div>
    <div class="formfields__container" [fxFlex]="flexPercent">
      <ng-container *ngIf="transaction.deal_type_agile_space === 'fill'">
        <h3 *ngIf="transaction.rep_role === 'tenant'" i18n>Tenant</h3>
        <h3 *ngIf="transaction.rep_role === 'landlord'" i18n>Landlord</h3>
        
        <ng-container *ngIf="!isPacificIsolationEnable()">
          <mat-form-field class="parties__name">
            <label for="other_counter_name" i18n>Name</label>
            <input id="other_counter_name" matInput  [value]="transaction.other_counter_party_contact" disabled />
          </mat-form-field>
          <mat-form-field class="parties__company">
            <label for="other_counter_company" i18n>Company</label>
            <input id="other_counter_company" matInput  [value]="transaction.other_counter_party_name" disabled />
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="isPacificIsolationEnable()">
          <mat-form-field class="parties__name">
            <label for="represented_account" i18n>Account</label>
            <input id="represented_name" matInput  [value]="edpAccountContactInfo?.other_party_account || ''" disabled />
          </mat-form-field>
          <mat-form-field class="parties__company">
            <label for="represented_contact" i18n>Contact</label>
            <input id="represented_contact" matInput  [value]="edpAccountContactInfo?.other_party_contact || ''" disabled />
          </mat-form-field>
        </ng-container>
      </ng-container>

      <h3 *ngIf="transaction.rep_role === 'buyer'" i18n>Seller</h3>
      <h3 *ngIf="transaction.rep_role === 'seller'" i18n>Buyer</h3>
      <h3 *ngIf="transaction.rep_role === 'landlord'" i18n>Tenant</h3>
      <h3 *ngIf="transaction.rep_role === 'tenant'" i18n>Landlord</h3>
      <h3 *ngIf="transaction.rep_role === 'borrower'" i18n>Lender</h3>
      <h3 *ngIf="transaction.rep_role === 'lender'" i18n>Borrower</h3>

      <ng-container *ngIf="!isPacificIsolationEnable() && transaction.rep_role !== 'client'">
        <ng-container *ngIf="transaction.rep_role !== 'seller' && transaction.counter_party_contact">
          <mat-form-field class="parties__name">
            <label for="counter_name" i18n>Name</label>
            <input id="counter_name" matInput  [value]="transaction.counter_party_contact" disabled />
          </mat-form-field>
        </ng-container>
        <mat-form-field class="parties__company" *ngIf="!transaction.multiple_buyers">
          <label for="counter_company" i18n>Company</label>
          <input id="counter_company" matInput  [value]="transaction.counter_party_name" disabled />
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="isPacificIsolationEnable() && !transaction.multiple_buyers">
        <mat-form-field class="parties__name">
          <label for="represented_account" i18n>Account</label>
          <input id="represented_name" matInput  [value]="edpAccountContactInfo?.counter_party_account || ''" disabled />
        </mat-form-field>
        <mat-form-field class="parties__company">
          <label for="represented_contact" i18n>Contact</label>
          <input id="represented_contact" matInput  [value]="edpAccountContactInfo?.counter_party_contact || ''" disabled />
        </mat-form-field>
      </ng-container>

      <div *ngIf="transaction.transaction_type === 'sale' && !transaction.multiple_buyers">
        <mat-form-field class="parties__vehiclename">
          <label for="counter_party_vehicle_name" i18n>Fund Name</label>
          <input id="counter_party_vehicle_name" maxLength="256" matInput [value]="transaction.counter_party_funding_vehicle" disabled />
        </mat-form-field>
        <mat-form-field class="parties__sourceequity">
          <label *ngIf="transaction.rep_role==='seller'" for="counter_party_equity_source" i18n>Origin of Buyer</label>
          <label *ngIf="transaction.rep_role==='buyer'" for="counter_party_equity_source" i18n>Origin of Seller</label>
          <input id="counter_party_equity_source" maxLength="256" matInput [value]="transaction.counter_party_equity_source" disabled />
        </mat-form-field>
      </div>

      <div *ngIf="!hideOtherPartyAddress() && transaction.rep_role !== 'client'"
        class="parties__address selected-value">
        <label for="address2" class="selected-value__label" i18n>Address</label>
        <div id="address2" class="selected-value__details address">
          <button mat-button matInput disabled>
            <div *ngIf="transaction.counter_party">
              <div class="address__name">{{transaction.counter_party_name}}</div>
              <div class="address__line">{{counter_party[0]?.addresses?.addresses[0]?.address_seq_num ? counter_party[0]?.addresses?.addresses[0]?.address_seq_num + '. ' : '' }} {{counter_party[0]?.addresses?.addresses[0]?.address1}}</div>
              <div class="address__line">{{counter_party[0]?.addresses?.addresses[0]?.address2}}</div>
              <div class="address__line">{{counter_party[0]?.addresses?.addresses[0]?.address3}}</div>
              <div class="address__line">{{counter_party[0]?.addresses?.addresses[0]?.address4}}</div>
              <div class="address__line">
                <span *ngIf="counter_party[0]?.addresses?.addresses[0]?.city">{{counter_party[0]?.addresses?.addresses[0]?.city}}, </span>
                <span *ngIf="counter_party[0]?.addresses?.addresses[0]?.state">{{counter_party[0]?.addresses?.addresses[0]?.state}}, </span>
                <span *ngIf="counter_party[0]?.addresses?.addresses[0]?.postal">{{counter_party[0]?.addresses?.addresses[0]?.postal}}, </span>
                <span>{{counter_party[0]?.addresses?.addresses[0]?.country}}</span>
              </div>
            </div>
          </button>
        </div>
      </div>

      <div *ngIf="transaction.multiple_buyers">
        <iv-multiple-buyer-checkbox
          [disabled]="true"
          [transaction]="transaction">
        </iv-multiple-buyer-checkbox>
        <iv-multiple-buyer-details
          [transaction]="transaction"
          [buyerDetails]="buyerDetails"
          [disabled]="true">
        </iv-multiple-buyer-details>
      </div>
    </div>
  </div>
</div>
